// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"197":"ui5-webcomponents-sap-icons-v5","804":"ui5-webcomponents-sap-icons-v4"}[chunkId] || chunkId) + "." + {"116":"6325bd2d","197":"064826c6","324":"f991b1bf","373":"e0c2d395","804":"3fdde252"}[chunkId] + ".chunk.js";
};